import { render } from "./viewCtqRegistry.vue?vue&type=template&id=77cca791&scoped=true"
import script from "./viewCtqRegistry.vue?vue&type=script&lang=js"
export * from "./viewCtqRegistry.vue?vue&type=script&lang=js"

import "./viewCtqRegistry.vue?vue&type=style&index=0&id=77cca791&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77cca791"]])

export default __exports__